import React from 'react';
import axios from 'axios';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Loader2, CheckCircle, XCircle } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export default function VerifyEmail() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const token = params.get('token') || '';
  const [state, setState] = React.useState('loading'); // loading | success | error

  React.useEffect(() => {
    if (!token) { setState('error'); return; }
    axios.post(`${API_URL}/api/auth/verify-email`, { token })
      .then(() => setState('success'))
      .catch(() => setState('error'));
  }, [token]);

  return (
    <div className="min-h-screen bg-[#050505] flex items-center justify-center pt-20 px-4">
      <div className="w-full max-w-md bg-zinc-900/50 border border-white/10 rounded-2xl p-8 text-center">
        {state === 'loading' ? (
          <>
            <Loader2 className="h-12 w-12 text-[#F9004D] animate-spin mx-auto mb-4" />
            <p className="text-zinc-300">{t('verifyEmail.verifying')}</p>
          </>
        ) : state === 'success' ? (
          <>
            <CheckCircle className="h-12 w-12 text-emerald-400 mx-auto mb-4" />
            <h1 className="text-xl font-bold text-white mb-2">{t('verifyEmail.successTitle')}</h1>
            <p className="text-zinc-400 text-sm mb-6">{t('verifyEmail.successDesc')}</p>
            <button onClick={() => navigate('/')} className="rounded-full bg-[#F9004D] hover:bg-[#D00040] text-white font-bold px-6 py-3">
              {t('verifyEmail.continueBtn')}
            </button>
          </>
        ) : (
          <>
            <XCircle className="h-12 w-12 text-red-400 mx-auto mb-4" />
            <h1 className="text-xl font-bold text-white mb-2">{t('verifyEmail.errorTitle')}</h1>
            <p className="text-zinc-400 text-sm mb-6">{t('verifyEmail.errorDesc')}</p>
            <button onClick={() => navigate('/')} className="rounded-full bg-[#F9004D] hover:bg-[#D00040] text-white font-bold px-6 py-3">
              {t('verifyEmail.continueBtn')}
            </button>
          </>
        )}
      </div>
    </div>
  );
}
